import {TweenMax, Power2} from 'gsap';
import Draggable from 'gsap/Draggable';
const EventEmitter = require('eventemitter3');
// import Draggable from '../../../../../../node_modules/gsap/Draggable';


const _init = function (ui) {
    ui.btns = [...ui.el.querySelectorAll('[data-option]')];
    ui.btn = ui.el.querySelector('[data-drag]');
    ui.bound = ui.el.querySelector('[data-area]');
    ui.map = {};
    ui.values = ui.btns.map(btn => {
        return btn.dataset.option;
    });
    ui.labels = ui.btns.map(btn => {
        return btn.dataset.optionLabel;
    });
    ui.selected = 0;
    ui.w = ui.bound.getBoundingClientRect().width;

    let i;
    for (i = 0; i <  ui.values.length; i++) {
        ui.map[ui.values[i]] = i;
    }

    ui.draggable = Draggable.create(ui.btn, {
        type: 'x',
        bounds: ui.bound,
        edgeResistance:0.65,
        dragResistance:0.1,
        throwProps: false,
        dragClickables: true,
        onDrag: function () {
            ui.el.dataset.active = true;
            TweenMax.killTweensOf(ui.btn);

            __setSyncXBack(ui, this.x);
        },
        onDragEnd: function () {

            const v = __liveSnap(ui, this.x);
            const i = Math.round(v / ui.w);
            TweenMax.to(ui, 0.25, {
                x: v,
                onUpdate: () => {
                    __syncX(ui);
                },
                onComplete: () => {
                    ui.el.dataset.active = false;
                    if (ui.selected !== i)
                        ui.emit('changed', ui.values[i], ui.labels[i]);
                    ui._update(ui.values[i], i, 0);
                },
                ease: Power2.easeInOut
            });
        }
    })[0];



    if (!ui._enabledDrag)
        ui.draggable.enabled(false, 'x');

    i = parseInt(ui.el.dataset.selected);
    ui._update(ui.values[i], i, 0);
};

const __liveSnap = function (ui, value) {

    return Math.max(0,  Math.min(1, Math.round(value / ui.w))) * ui.w;
};

const _enable = function () {
    const ui = this;
    if (ui._enabled) return;

    ui.el.classList.add('active');
    _addEventListeners(ui);

    if (ui.isDraggable)
        ui.enableDrag();

    ui._enabled = true;
};

const _disable = function () {
    const ui = this;
    if (!ui._enabled) return;

    ui.el.classList.remove('active');
    _addEventListeners(ui, false);

    ui.disableDrag();

    ui._enabled = false;
};

const _enableDrag = function () {
    const ui = this;
    if (ui._enabledDrag) return;
    ui.draggable.enabled(true, 'x');
    _addEventListenersDrag(ui);
    ui._enabledDrag = true;
};

const _disableDrag = function () {
    const ui = this;
    if (!ui._enabledDrag) return;
    ui.draggable.enabled(false, 'x');
    _addEventListenersDrag(ui, false);
    ui._enabledDrag = false;
};

const _destroy = function () {
    const ui = this;
    ui.disable();
    ui.removeAllListeners();

    delete ui.el.data.uiController;
};

const _resize = function (sizeMode) {
    const ui = this;
    ui.w = ui.bound.getBoundingClientRect().width;
    ui._update(ui.values[ui.selected], ui.selected, 0);

    ui.isDraggable = !(sizeMode === 'mobile_portrait' || sizeMode === 'mobile_landscape');
    if (!ui.isDraggable || !ui._enabled)
        ui.disableDrag();
    else
        ui.enableDrag();

};

const _update = function (value, i, dur = 0.25) {
    const ui = this;
    if (typeof value === 'undefined' || i < 0 || i > ui.btns.length - 1) return;
    ui.btns[ui.selected].dataset.optionSelected = false;
    ui.el.dataset.selected = ui.selected = i;
    ui.el.dataset.selectedOption = ui.selectedOption = value;
    ui.btns[i].dataset.optionSelected = true;

    TweenMax.to(ui, dur, {
        x: ui.selected * ui.w,
        onUpdate: () => {
            __syncX(ui);
        }
    });
};

const __setSyncXBack = function (ui, x) {
    TweenMax.set(ui, {
        x: x
    });
};

const __syncX = function (ui) {
    TweenMax.set(ui.btn, {
        x: ui.x
    });
};

const _addEventListeners = function (ui, b) {

    if (b === false) {
        ui.btns.forEach((btn, i) => {
            btn.removeEventListener('click', ui._onClick[i]);
        });
        ui._onClick.splice(0, ui._onClick.length);
        return;
    }

    ui._onClick = [];

    ui.btns.forEach((btn, i) => {

        const value = btn.dataset.option;
        const f = () => {
            if (typeof value === 'undefined') return;
            ui._update(value, i);
            ui.emit('changed', value, btn.dataset.optionLabel);
        };
        ui._onClick.push(f);
        btn.addEventListener('click', f);
    });
};

const _addEventListenersDrag = function (ui, b) {

    if (b === false) {
        ui.bound.removeEventListener('click', ui._onClickBound);
        ui._onClickBound = undefined;
        return;
    }

    ui._onClickBound = () => {

        let i = ui.selected + 1;
        if (i > ui.values.length - 1) i = 0;
        ui._update(ui.values[i], i);
        ui.emit('changed', ui.values[i], ui.labels[i]);
    };

    ui.bound.addEventListener('click', ui._onClickBound);
};

module.exports = el => {

    if (el.data && el.data.uiController) return el.data.uiController;

    const ui = new EventEmitter();
    ui.el = el;

    ui.el.data = ui.el.data || {};
    ui.el.data.uiController = ui;

    ui.type = 'option-switcher';
    ui.enable = _enable.bind(ui);
    ui.disable = _disable.bind(ui);
    ui.enableDrag = _enableDrag.bind(ui);
    ui.disableDrag = _disableDrag.bind(ui);
    ui.destroy = _destroy.bind(ui);
    ui.resize = _resize.bind(ui);
    ui._update = _update.bind(ui);
    ui.getValue = () => { return ui.selectedOption; };
    ui.setValue = value => {
        if (!ui.map.hasOwnProperty(value)) return ui.selectedOption;
        const i = ui.map[value];
        ui._update(value, i);
        return ui.selectedOption;
    };

    _init(ui);

    return ui;
}


// WEBPACK FOOTER //
// ./js/viscom/kaspersky/risksOverview/ui/OptionSwitcher.js